import "../../src/App.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const Basicprojects = () => {
  return (
    <>
      <Navbar />

      <div class="container container-center ">
        <section class="section blue">
          <h1>Quiz Website</h1>
          <p>
            A fun quiz app based on latest webshows , cartoons and animes made
            with <strong>ReactJS</strong> .
          </p>
          <a
            class="link link-primary"
            href="https://quiz-anamkaa.vercel.app/"
            target="/"
          >
            Live Project
          </a>
          <a
            class="link link-primary"
            href="https://github.com/anamkaa/quiz"
            target="/"
          >
            See Code
          </a>
        </section>
      </div>

      <div class="container container-center ">
        <section class="section blue">
          <h1>Stock Guide</h1>

          <p>
            A website which tells the user how much profit or loss they are
            making on a stock. Click on live project and try it. Built with{" "}
            <strong>HTML , CSS</strong> and <strong>Vanilla JS</strong>.
          </p>
          <a
            class="link link-primary"
            href="https://check-ur-stocks.netlify.app/"
            target="/"
          >
            Live Project
          </a>
          <a
            class="link link-primary"
            href="https://github.com/anamkaa/check-stock"
            target="/"
          >
            See Code
          </a>
        </section>
      </div>

      <div class="container container-center ">
        <section class="section blue">
          <h1>Palindrome Birthday</h1>
          <p>
            An app that justs takes your birthday as an input and tells you
            whether it's palindrome or not. Sounds interesting, right? Go ahead
            and try it.Built with <strong>HTML , CSS</strong> and{" "}
            <strong>Vanilla JS</strong>.
          </p>
          <a
            class="link link-primary"
            href="https://check-palindrome-bday.netlify.app/"
            target="/"
          >
            Live Project
          </a>
          <a
            class="link link-primary"
            href="https://github.com/anamkaa/Is-birthday-palindrome"
            target="/"
          >
            See Code
          </a>
        </section>
      </div>

      <div class="container container-center ">
        <section class="section blue">
          <h1>Fun with Triangles</h1>
          <p>
            Triangle facts and trivia turned into a fun app. Click on the live
            project to try it.Built with <strong>HTML , CSS</strong> and{" "}
            <strong>Vanilla JS</strong>.
          </p>
          <a
            class="link link-primary"
            href="https://triangle-test.netlify.app/"
            target="/"
          >
            Live Project
          </a>
          <a
            class="link link-primary"
            href="https://github.com/anamkaa/try-triangle"
            target="/"
          >
            See Code
          </a>
        </section>
      </div>

      <div class="container container-center ">
        <section class="section blue">
          <h1>Lucky Birthday</h1>
          <p>
            Try this app and get to know if your birthday is lucky or not.Built
            with <strong>HTML , CSS</strong> and <strong>Vanilla JS</strong>.
          </p>
          <a
            class="link link-primary"
            href="https://check-ur-bday.netlify.app/"
            target="/"
          >
            Live Project
          </a>
          <a
            class="link link-primary"
            href="https://github.com/anamkaa/check-birthday"
            target="/"
          >
            See Code
          </a>
        </section>
      </div>

      <div class="container container-center ">
        <section class="section blue">
          <h1>Cash Register App</h1>
          <p>
            A cash register app which will help the user by telling how can they
            return the change to the customer with minimum number of notes.Built
            with <strong>HTML , CSS</strong> and <strong>Vanilla JS</strong>.
          </p>
          <a
            class="link link-primary"
            href="https://cash-check.netlify.app/"
            target="/"
          >
            Live Project
          </a>
          <a
            class="link link-primary"
            href="https://github.com/anamkaa/cash-app"
            target="/"
          >
            See Code
          </a>
        </section>
      </div>

      <div class="container container-center ">
        <section class="section blue">
          <h1>Movie Recommendation App</h1>
          <p>
            You're a Cinephile too? Get recommendation of some highly rated
            movies based on genres.Built with <strong>ReactJS</strong>.
          </p>
          <a class="link link-primary" href="https://bo0ug.csb.app/">
            Live Project
          </a>
          <a
            class="link link-primary"
            href="https://github.com/anamkaa/recommendation-app"
            target="/"
          >
            See Code
          </a>
        </section>
      </div>

      <div class="container container-center ">
        <section class="section blue">
          <h1>Emoji Interpreter</h1>
          <p>
            Finding emojis and their meanings made easy. Try this app to
            level-up your emoji game.Built with <strong>ReactJS</strong>.
          </p>
          <a class="link link-primary" href="https://z6frk.csb.app/">
            Live Project
          </a>
          <a
            class="link link-primary"
            href="https://github.com/anamkaa/ask-emoji"
            target="/"
          >
            See Code
          </a>
        </section>
      </div>

      <div class="container container-center ">
        <section class="section blue">
          <h1>Ferb Translate</h1>
          <p>
            During their routine summer fun, the two brothers Phineas and Ferb
            created their own language, Ferb Latin. Use this translator to
            convert english to ferb latin.Built with <strong>HTML , CSS</strong>{" "}
            and <strong>Vanilla JS</strong>.
          </p>
          <a
            class="link link-primary"
            href="https://ferb-translate.netlify.app/"
            target="/"
          >
            Live Project
          </a>
          <a
            class="link link-primary"
            href="https://github.com/anamkaa/ferb-translate"
            target="/"
          >
            See Code
          </a>
        </section>
      </div>

      <div class="container container-center ">
        <section class="section blue">
          <h1>Minion Translator</h1>
          <p>
            Did you know that the gibberish minions say is an actual language
            called minionese or banana language. Use the translator to convert
            your text from English to Banana language.Built with{" "}
            <strong>HTML , CSS</strong> and <strong>Vanilla JS</strong>.
          </p>
          <a
            class="link link-primary"
            href="https://my-minionese.netlify.app/"
            target="/"
          >
            Live Project
          </a>
          <a
            class="link link-primary"
            href="https://github.com/anamkaa/minion-talk"
            target="/"
          >
            See Code
          </a>
        </section>
      </div>

      <Footer />

      {/* <footer class="footer">
        <div class="footer-header">Social Links</div>
        <ul class="social-links list-non-bullet">
          <li class="list-item-inline">
            <a
              class="link"
              href="https://www.linkedin.com/in/anamkaa/"
              target="/"
            >
              <LinkedinLogo size={32} weight="fill" />
            </a>
          </li>
          <li class="list-item-inline">
            <a class="link" href="https://github.com/anamkaa" target="/">
              <GithubLogo size={32} weight="fill" />
            </a>
          </li>
          <li class="list-item-inline">
            <a class="link" href="https://twitter.com/anamkaa_" target="/">
              <TwitterLogo size={32} weight="fill" />
            </a>
          </li>
        </ul>
      </footer> */}
    </>
  );
};

export default Basicprojects;
